import * as React from 'react';
import Wrapper from '@components/Wrapper';
import patternLeftInverted from '@patterns/leftInverted';
import patternRightInverted from '@patterns/rightInverted';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as styles from './style.module.scss';
const {
  quote,
  quoteSecondary,
  quoteSuccess,
  quoteNumbers,
  quote__content,
  quote__icon,
  quote__data,
  quote__author,
  quote__author__image,
  quote__author__text,
  quote__bgPattern,
  quote__wrapper
} = styles;

const Quote = ({text, author, icon, theme="blue", id, type, contentfulIcon, isNumbers}) => {
  return (
    <section className={`${quote} ${type === 'secondary' ? quoteSecondary : ""} ${type === 'quote' ? quoteSuccess : ""} ${isNumbers && quoteNumbers}`} id={id}>
      <Wrapper classes={quote__wrapper}>
        <div className={quote__bgPattern}>
          {patternRightInverted}
          {patternLeftInverted}
        </div>
        <div className={`${quote__content} background--${theme}`}>

          <div className={quote__icon} style={contentfulIcon ? { width: `${contentfulIcon.width / 3}px`, height: `${contentfulIcon.height / 3}px` } : {}}>
            {icon && <div dangerouslySetInnerHTML={{__html: icon}}/>}
            {contentfulIcon && <GatsbyImage image={getImage(contentfulIcon)} alt="quote logo" quality={100} />}
          </div>
          <div className={quote__data}>
            <h5>{text}</h5>
            {author && <div className={quote__author}>
                {author.avatar &&
                  <div className={quote__author__image}>
                    <GatsbyImage image={getImage(author.avatar?.gatsbyImageData)} alt="quote author image" quality={100} />
                  </div>
                }
                <div className={quote__author__text}>
                  <p><strong>{author.name}</strong></p>
                  <p>{author.position}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </Wrapper>
    </section>
  )
}

export default Quote;
